import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { PlatformService } from '@examdojo/platform';
import { ButtonComponent } from '@examdojo/core/button';
import { ModalController } from '@ionic/angular/standalone';
import { SKIP_QUESTION_DIALOG_ID } from './skip-question-dialog.service';

@Component({
  selector: 'dojo-skip-question-dialog',
  imports: [ButtonComponent],
  templateUrl: './skip-question-dialog.component.html',
  styleUrl: './skip-question-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipQuestionDialogComponent {
  constructor(
    private readonly modalController: ModalController,
    private readonly platformService: PlatformService,
  ) {}

  readonly state = connectState({
    isMobile: this.platformService.isSmall$,
  });

  skipQuestion() {
    this.modalController.dismiss(true, undefined, SKIP_QUESTION_DIALOG_ID);
  }

  closeDialog() {
    this.modalController.dismiss(false, undefined, SKIP_QUESTION_DIALOG_ID);
  }
}
